import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { OrderService } from 'src/app/shared/services/order-service';
import { Order } from 'src/app/shared/models/order';
import { take } from 'rxjs/operators';
import * as _ from "lodash";
@Component({
  selector: 'app-delivery-information',
  templateUrl: './delivery-information.component.html',
  styleUrls: ['./delivery-information.component.scss']
})
export class DeliveryInformationComponent implements OnInit {

  constructor(private orderService: OrderService) { }
  @Output() stepConfirm = new EventEmitter<number>();
  firstName: string;
  lastName: string;
  mail: string;
  diners: number = 1;
  cutlery:boolean=false;
  remark:string="";
  order: Order;
  error:string;
  ngOnInit(): void {
    this.orderService.getOrder().pipe(take(1)).subscribe(order => {
      this.order = order;
      this.firstName=order.firstName;
      this.lastName=order.lastName;
      this.remark=order.remarks;
      this.mail=order.email;
      this.diners=order.diners;
    })
  }

  plusDiner() {
    this.diners = this.diners + 1;
  }

  minusDiner() {
    this.diners = this.diners > 1 ? this.diners - 1 : 1;
  }

  addCutlery(){
    this.cutlery=!this.cutlery;
  }

  remarkChange(event){
    this.remark=event;
  }

  confirm(){
    if(!this.formValid()){
      return;
    }
    this.orderService.setOrder({firstName:this.firstName, lastName:this.lastName, remarks:this.remark, diners:this.diners, email:this.mail})
    this.stepConfirm.emit(1);
  }

  back(){
    this.stepConfirm.emit(-1);
  }

  formValid():boolean{
    this.error=null;
    if (_.isNil(this.firstName)){
      this.error="אנא הזן שם פרטי";
      return false;
    }
    if (_.isNil(this.lastName)){
      this.error="אנא הזן שם משפחה";
      return false;
    }
    if (_.isNil(this.mail)){
      this.error="אנא הזן מייל";
      return false;
    }
    return true;
  }

}
